import { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';

import { Button } from '@Components/Button';
import { Appearance, Design } from '@Components/designConstants';
import './OverrideRotationModal.scss';

interface OverrideRotationModalProps {
  addOverrideRotation: (overrideRotation: string) => void;
  onClose: () => void;
}

export const OverrideRotationModal = ({
  addOverrideRotation,
  onClose
}: OverrideRotationModalProps) => {
  const [overrideRotation, setOverrideRotation] = useState('');
  return (
    <Modal show onHide={onClose} className='override-rotation-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Override Rotation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Control
            type='text'
            value={overrideRotation}
            onChange={e => {
              setOverrideRotation(e.target.value);
            }}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button appearance={Appearance.OUTLINED} design={Design.NEUTRAL} onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={!overrideRotation} onClick={() => addOverrideRotation(overrideRotation)}>
          Override
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
